<template>
  <div id="content">
    <div id="videodetail">
    <div class="videodetail">
      <div class="video-con le">
      <div class="con le">
        <span  v-if="$i18n.locale == 'en'"  class="video-tit le">{{video.name_en}}</span>
        <span  v-else  class="video-tit le">{{video.name}}</span>
<br/>
        <span  v-if="$i18n.locale == 'en'"  class="font14px26 le">
          DATE:{{video.year}}-{{video.month}}-{{video.day}}
          <span class="br"></span>BROWER：{{video.tickcount}}
        </span><span  v-else  class="font14px26 le">
          日期：{{video.year}}-{{video.month}}-{{video.day}}
          <span class="br"></span>浏览：{{video.tickcount}}
        </span>
        <span class="vv le"><iframe class="iframevideo" :src="video.url" frameborder="0" width="100%" allowfullscreen=""></iframe></span>
      </div>
    <div v-if="$i18n.locale == 'en'"   v-html="video.content_en">
    </div>
    <div  v-else  v-html="video.content">
    </div>
    </div>
    </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/js/axios";
export default {
  components: {},
  name: 'NewsDetail',
   data() {
    return {
      video:{},
    };
  },
  mounted() {
    // 使用
    const params = {id: this.$route.query.id}; // 参数
    fetch.post("/api/ApiVideo/Get", params).then(
      (res) => {
        this.video = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  }
}

</script>

<style>
#videodetail {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
  margin-top:10px;
}
.videodetail {
  width: 100%;
  overflow: hidden;
}
.iframevideo{ min-height: 400px;}
/* .video{width:100%;height: auto;background: #f6f6f6;}
.video .video-wrapper{width:100%;height: auto;margin: 0 auto;} */
.video .video-wrapper .video-con{width:100%;height: auto;border-radius: 10px;background: #fff;margin: 80px 0;}
.video-con .con{width:100%;height: auto;}
.video-con .con .video-tit{width:100%;height: auto;font-size: 30px;font-weight: bold;line-height: 40px;margin-bottom: 10px;}
.video-con .con .font14px26{width:100%;height: auto;line-height: 26px;font-size: 14px;color:#b5b5b5;margin-bottom: 10px;}
.video-con .con .font14px26 .br{margin-left: 20px;}
.video .video-wrapper .video-more{width:387px;height: auto;margin: 80px 0;}
.video .video-wrapper .video-more .more-tit{width:100%;height: auto;font-size: 20px;line-height: 30px;font-weight: bold;color:#000000;margin-bottom: 30px;}
.video-con .con .vv{width:100%;}
.video-con .con .vv img{width:100%;}
</style>



// WEBPACK FOOTER //
// src/views/VideoDetail.vue